module.exports = __webpack_public_path__ + "img/icon-technology.92e496a2.svg";